import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=59bc65f2&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=59bc65f2&scoped=true&lang=css&"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=59bc65f2&scoped=true&lang=css&"
import style2 from "./NewsDetail.vue?vue&type=style&index=2&id=59bc65f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc65f2",
  null
  
)

export default component.exports